export function getstatusOperator(state) {
  return state.statusOperator
}

export function getFetchSearch(state) {
  return state.fetchSearch
}
